import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { OriginalTermsObj } from "../../utils/types";

const initialState: OriginalTermsObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getOriginalTermsData = createAsyncThunk(
  "loans/getOriginalTermsDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url, true);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const originalTermsDetailsSlice = createSlice({
  name: "originalTerms",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOriginalTermsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOriginalTermsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getOriginalTermsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default originalTermsDetailsSlice.reducer;
